/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
import { Directive, Input, Optional } from '@angular/core';
import { MatDialogRef } from './dialog-ref';
import { MatDialogContainer } from './dialog-container';
/**
 * Counter used to generate unique IDs for dialog elements.
 */
let dialogElementUid = 0;
/**
 * Button that will close the current dialog.
 */
export class MatDialogClose {
    /**
     * @param {?} dialogRef
     */
    constructor(dialogRef) {
        this.dialogRef = dialogRef;
        /**
         * Screenreader label for the button.
         */
        this.ariaLabel = 'Close dialog';
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        const /** @type {?} */ proxiedChange = changes._matDialogClose || changes._matDialogCloseResult;
        if (proxiedChange) {
            this.dialogResult = proxiedChange.currentValue;
        }
    }
}
MatDialogClose.decorators = [
    { type: Directive, args: [{
                selector: `button[mat-dialog-close], button[matDialogClose]`,
                exportAs: 'matDialogClose',
                host: {
                    '(click)': 'dialogRef.close(dialogResult)',
                    '[attr.aria-label]': 'ariaLabel',
                    'type': 'button',
                }
            },] },
];
/**
 * @nocollapse
 */
MatDialogClose.ctorParameters = () => [
    { type: MatDialogRef, },
];
MatDialogClose.propDecorators = {
    'ariaLabel': [{ type: Input, args: ['aria-label',] },],
    'dialogResult': [{ type: Input, args: ['mat-dialog-close',] },],
    '_matDialogClose': [{ type: Input, args: ['matDialogClose',] },],
};
function MatDialogClose_tsickle_Closure_declarations() {
    /** @type {?} */
    MatDialogClose.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    MatDialogClose.ctorParameters;
    /** @type {?} */
    MatDialogClose.propDecorators;
    /**
     * Screenreader label for the button.
     * @type {?}
     */
    MatDialogClose.prototype.ariaLabel;
    /**
     * Dialog close input.
     * @type {?}
     */
    MatDialogClose.prototype.dialogResult;
    /** @type {?} */
    MatDialogClose.prototype._matDialogClose;
    /** @type {?} */
    MatDialogClose.prototype.dialogRef;
}
/**
 * Title of a dialog element. Stays fixed to the top of the dialog when scrolling.
 */
export class MatDialogTitle {
    /**
     * @param {?} _container
     */
    constructor(_container) {
        this._container = _container;
        this.id = `mat-dialog-title-${dialogElementUid++}`;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        if (this._container && !this._container._ariaLabelledBy) {
            Promise.resolve().then(() => this._container._ariaLabelledBy = this.id);
        }
    }
}
MatDialogTitle.decorators = [
    { type: Directive, args: [{
                selector: '[mat-dialog-title], [matDialogTitle]',
                exportAs: 'matDialogTitle',
                host: {
                    'class': 'mat-dialog-title',
                    '[id]': 'id',
                },
            },] },
];
/**
 * @nocollapse
 */
MatDialogTitle.ctorParameters = () => [
    { type: MatDialogContainer, decorators: [{ type: Optional },] },
];
MatDialogTitle.propDecorators = {
    'id': [{ type: Input },],
};
function MatDialogTitle_tsickle_Closure_declarations() {
    /** @type {?} */
    MatDialogTitle.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    MatDialogTitle.ctorParameters;
    /** @type {?} */
    MatDialogTitle.propDecorators;
    /** @type {?} */
    MatDialogTitle.prototype.id;
    /** @type {?} */
    MatDialogTitle.prototype._container;
}
/**
 * Scrollable content container of a dialog.
 */
export class MatDialogContent {
}
MatDialogContent.decorators = [
    { type: Directive, args: [{
                selector: `[mat-dialog-content], mat-dialog-content, [matDialogContent]`,
                host: { 'class': 'mat-dialog-content' }
            },] },
];
/**
 * @nocollapse
 */
MatDialogContent.ctorParameters = () => [];
function MatDialogContent_tsickle_Closure_declarations() {
    /** @type {?} */
    MatDialogContent.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    MatDialogContent.ctorParameters;
}
/**
 * Container for the bottom action buttons in a dialog.
 * Stays fixed to the bottom when scrolling.
 */
export class MatDialogActions {
}
MatDialogActions.decorators = [
    { type: Directive, args: [{
                selector: `[mat-dialog-actions], mat-dialog-actions, [matDialogActions]`,
                host: { 'class': 'mat-dialog-actions' }
            },] },
];
/**
 * @nocollapse
 */
MatDialogActions.ctorParameters = () => [];
function MatDialogActions_tsickle_Closure_declarations() {
    /** @type {?} */
    MatDialogActions.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    MatDialogActions.ctorParameters;
}
//# sourceMappingURL=dialog-content-directives.js.map